import React from 'react';
import {
  FaHome,
  FaMapMarkedAlt,
  FaUsers,
  FaCalendarAlt,
  FaClipboardList,
  FaChartPie,
  FaComments,
  FaTools,
} from 'react-icons/fa';
import {
  CLUB_SECTION_ORDER,
  CLUB_SECTIONS,
} from '../clubSections';
import './clubTileHub.css';

/** Same icon set as ClubTabsNav — keep tile hub consistent with category chrome. */
const TILE_ICONS = {
  overview: FaHome,
  map: FaMapMarkedAlt,
  members: FaUsers,
  calendar: FaCalendarAlt,
  rules: FaClipboardList,
  stats: FaChartPie,
  board: FaComments,
  admin: FaTools,
};

function memberSubLine(memberCount) {
  const n = Number(memberCount);
  if (!Number.isFinite(n) || n < 0) return 'MEMBERS';
  return `${n} MEMBER${n === 1 ? '' : 'S'}`;
}

/**
 * Mobile club detail tile hub (handoff 3 §5). Desktop keeps ClubTabsNav.
 */
export function ClubTileHub({
  isPresident = false,
  joinGateActive = false,
  boardUnreadCount = 0,
  memberCount = 0,
  onSelect,
}) {
  const tiles = CLUB_SECTION_ORDER.filter(
    (key) => !CLUB_SECTIONS[key].gated || isPresident
  );

  return (
    <div className="club-tile-hub" data-testid="club-tile-hub" role="navigation" aria-label="Club sections">
      {tiles.map((key) => {
        const section = CLUB_SECTIONS[key];
        const Icon = TILE_ICONS[key] || FaHome;
        const locked = joinGateActive && key !== 'rules';
        const sub =
          locked
            ? 'ACKNOWLEDGE RULES FIRST'
            : key === 'members'
              ? memberSubLine(memberCount)
              : section.sub;
        const badge =
          key === 'board' && boardUnreadCount > 0
            ? boardUnreadCount > 99
              ? '99+'
              : String(boardUnreadCount)
            : null;

        return (
          <button
            key={key}
            type="button"
            className={`club-tile${locked ? ' club-tile--locked' : ''}`}
            data-testid={`club-tile-${key}`}
            aria-label={section.label}
            aria-disabled={locked}
            disabled={locked}
            onClick={() => {
              if (!locked && onSelect) onSelect(key);
            }}
          >
            <span className="club-tile__glyph" aria-hidden="true">
              <Icon size={16} />
            </span>
            <span className="club-tile__title">{section.label}</span>
            <span className="club-tile__sub">{sub}</span>
            {badge ? (
              <span className="club-tile__badge" aria-label={`${boardUnreadCount} unread board posts`}>
                {badge}
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}

/** Full-width back control — entire bar is the hit target, not just the label text. */
export function ClubHubBackBar({ sectionKey, onBack }) {
  const label = CLUB_SECTIONS[sectionKey]?.label || 'Section';
  return (
    <button
      type="button"
      className="club-hub-back"
      data-testid="club-hub-back"
      aria-label={`All sections. Current: ${label}`}
      onClick={onBack}
    >
      <span className="club-hub-back__link">‹ ALL SECTIONS</span>
      <span className="club-hub-back__title">{label}</span>
    </button>
  );
}

export default ClubTileHub;
